// Listellos (renforts des plans de 4 cm), Nils 28/10 : sortis par « Consommation atelier », hors dossier.
// Partagé par l'ERP (choix du lot) et le serveur (contrôle de l'enregistrement).
//   - tranche entière : seulement si son article du Catalogue est coché « Utilisable en listello »
//     (par le Gérant), au quart de tranche ;
//   - chute : toute chute de moins de 1 m², à la pièce.

export const TYPE_CHUTE = "chute";
export const SURFACE_MAX_CHUTE_LISTELLO = 1;

// « 66x320 » (cm) -> 2,11 m² (même calcul que surfaceM2 de l'ERP).
export function surfaceDimensions(dim) {
  if (!dim) return null;
  const nums = String(dim).match(/[\d.,]+/g);
  if (!nums || nums.length < 2) return null;
  const a = parseFloat(nums[0].replace(",", "."));
  const b = parseFloat(nums[1].replace(",", "."));
  if (!a || !b) return null;
  return Math.round((a / 100) * (b / 100) * 100) / 100;
}

export function lotUtilisableListello(lot, articles) {
  if (!lot) return false;
  if (lot.type === TYPE_CHUTE) {
    const s = surfaceDimensions(lot.dimensions);
    return s !== null && s < SURFACE_MAX_CHUTE_LISTELLO;
  }
  const a = (articles || []).find((x) => x && x.produitStockId && x.produitStockId === lot.produitId);
  return !!(a && a.categorie === "Tranche" && a.utilisableListello);
}

// Quantité acceptée : chute à la pièce (entier), tranche au quart.
export function quantiteListelloValide(lot, q) {
  const n = Number(q);
  if (!isFinite(n) || n <= 0) return false;
  return lot && lot.type === TYPE_CHUTE ? Number.isInteger(n) : Math.abs(n * 4 - Math.round(n * 4)) < 1e-9;
}
